import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { MessagesStoreModule } from '@bepatient/messages-store';
import { IonicModule } from '@ionic/angular';

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.MESSAGES,
  i18nLabel: 'MODULES.MESSAGES',
  icon: 'mail',
  leftMenuAvailableForPages: [0, 1, 2, 3],
  routes: [
    {
      path: 'discussions',
      loadChildren: () =>
        import('./pages/discussions/discussions.module').then(
          m => m.DiscussionsPageModule
        )
    },
    {
      path: 'discussion',
      loadChildren: () =>
        import('./pages/discussion/discussion.module').then(
          m => m.DiscussionPageModule
        )
    },
    {
      path: 'contacts',
      loadChildren: () =>
        import('./pages/contacts/contacts.module').then(
          m => m.ContactsPageModule
        )
    }
  ]
};

@NgModule({
  imports: [
    MessagesStoreModule,
    CommonModule,
    IonicModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './messages/i18n/', multi: true }
  ]
})
export class MessagesModule {}
